import { createContext, useReducer } from 'react';

import {
    MICROSOFT_GRAPH,
    APP_AUTH,
    DIRECT_ROUTING,
    OPERATOR_CONNECT,
    ZOOM,
    ZOOM_AUTH,
    ACS,
    OPERATOR_CONNECT_CONFERENCING,
    EIGHTBYEIGHT,
    EIGHTBYEIGHT_AUTH,
    SBC,
    VENDOR_DEFINED,
    GCC_HIGH,
    WEBEX,
    WEBEX_AUTH,
    OPERATOR_PLATFORM,
    RINGCENTRAL,
    RINGCENTRAL_AUTH,
    DIALPAD,
    DIALPAD_AUTH,
} from 'pages/dashboards/v5/constants';
import { statusReducer } from 'pages/dashboards/v5/statusReducer';

const initialState = {
    [MICROSOFT_GRAPH]: {
        color: 'gray',
        animation: false,
    },
    [APP_AUTH]: {
        color: 'gray',
        animation: false,
    },
    [OPERATOR_CONNECT]: {
        color: 'gray',
        animation: false,
    },
    [DIRECT_ROUTING]: {
        color: 'gray',
        animation: false,
    },
    [ZOOM]: {
        color: 'gray',
        animation: false,
    },
    [ZOOM_AUTH]: {
        color: 'gray',
        animation: false,
    },
    [EIGHTBYEIGHT]: {
        color: 'gray',
        animation: false,
    },
    [EIGHTBYEIGHT_AUTH]: {
        color: 'gray',
        animation: false,
    },
    [SBC]: {
        color: 'gray',
        animation: false,
    },
    [ACS]: {
        color: 'green',
        animation: false,
        hasStripes: false,
        statusLabel: 'Healthy',
    },
    [OPERATOR_CONNECT_CONFERENCING]: {
        color: 'green',
        animation: false,
        hasStripes: false,
        statusLabel: 'Healthy',
    },
    [VENDOR_DEFINED]: {
        color: 'gray',
        animation: false,
    },
    [OPERATOR_PLATFORM]: {
        color: 'gray',
        animation: false,
    },
    [GCC_HIGH]: {
        color: 'gray',
        animation: false,
    },
    [WEBEX]: {
        color: 'gray',
        animation: false,
    },
    [WEBEX_AUTH]: {
        color: 'gray',
        animation: false,
    },
    [RINGCENTRAL]: {
        color: 'gray',
        animation: false,
    },
    [RINGCENTRAL_AUTH]: {
        color: 'gray',
        animation: false,
    },
    [DIALPAD]: {
        color: 'gray',
        animation: false,
    },
    [DIALPAD_AUTH]: {
        color: 'gray',
        animation: false,
    },
    service: {
        [MICROSOFT_GRAPH]: {},
        [APP_AUTH]: {},
        [OPERATOR_CONNECT]: {},
        [DIRECT_ROUTING]: {},
        [ZOOM]: {},
        [ZOOM_AUTH]: {},
        [ACS]: {},
        [SBC]: {},
        [VENDOR_DEFINED]: {},
        [GCC_HIGH]: {},
        [WEBEX]: {},
        [WEBEX_AUTH]: {},
        [RINGCENTRAL]: {},
        [RINGCENTRAL_AUTH]: {},
        [DIALPAD]: {},
        [DIALPAD_AUTH]: {},
    },
};
const ServicesDashboardContext = createContext(initialState);
const ServicesDashboardDispatchContext = createContext(() => ({}));
ServicesDashboardContext.displayName = 'ServicesDashboardContext';

export const ServicesDashboardProvider = (props) => {
    const [serviceStatus, dispatch] = useReducer(statusReducer, initialState);

    return (
        <ServicesDashboardContext.Provider value={serviceStatus}>
            <ServicesDashboardDispatchContext.Provider value={dispatch}>
                {props.children}
            </ServicesDashboardDispatchContext.Provider>
        </ServicesDashboardContext.Provider>
    );
};

export { ServicesDashboardContext, ServicesDashboardDispatchContext };
